<template>
    <div>
        <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
            <form @submit.prevent="form.post(action)">
                <div class="px-4 py-5 bg-white sm:p-6 shadow-xl rounded-tl-md rounded-tr-md">
                    <div class="mt-3">
                        <jet-label for="partner_id" value="Partner"/>
                        <vue-multiselect
                            v-model="selectedPartner"
                            :options="partners"
                            label="name"
                            track-by="id"
                        />
                        <div v-if="form.errors.partner_id" class="mt-2 text-sm text-red-600">{{ form.errors.partner_id }}</div>
                    </div>

                    <div class="mt-3">
                        <jet-label for="name" value="Name"/>
                        <jet-input id="name" class="mt-1 block w-full" type="text" v-model="form.name"/>
                        <div v-if="form.errors.name" class="mt-2 text-sm text-red-600">{{ form.errors.name }}</div>
                    </div>

                    <div class="mt-3">
                        <jet-label for="name" value="ESP List ID"/>
                        <jet-input id="name" class="mt-1 block w-full" type="text" v-model="form.esp_list_id"/>
                        <div v-if="form.errors.esp_list_id" class="mt-2 text-sm text-red-600">{{ form.errors.esp_list_id }}</div>
                    </div>
                </div>

                <div class="px-4 py-5 bg-white sm:p-6 shadow-xl rounded-tl-md rounded-tr-md">
                    <h3 class="text-lg">Filters</h3>
                    <div class="mt-3">
                        <jet-label for="partner_id" value="Domains"/>
                        <vue-multiselect
                            v-model="form.filters.domains"
                            :options="domains"
                            multiple
                            taggable
                            @tag="addDomain"
                        />
                        <div v-if="filterErrors('domains').length > 0" class="mt-2">
                            <div v-for="error in filterErrors('domains')" class="mt text-sm text-red-600">{{ error }}</div>
                        </div>
                    </div>
                </div>

                <div class="flex items-center justify-end px-4 py-3 bg-gray-50 text-right sm:px-6 shadow-xl sm:rounded-bl-md sm:rounded-br-md">
                    <inertia-link
                        class="rounded-md border border-transparent bg-yellow-400 hover:bg-yellow-300 transition inline-flex items-center px-4 py-2 mr-2 text-xs text-white uppercase tracking-widest font-semibold"
                        :href="route('segments.index')">
                        Cancel
                    </inertia-link>
                    <jet-button :disabled="form.processing">{{ button }}</jet-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import {useForm} from '@inertiajs/inertia-vue3';
import JetButton from '@/Jetstream/Button';
import JetInput from '@/Jetstream/Input';
import JetLabel from '@/Jetstream/Label';
import VueMultiselect from 'vue-multiselect';
import _ from 'lodash';
import {computed, ref} from 'vue';

export default {
    props: ['segment', 'partners', 'verticals', 'action', 'method', 'button', 'domains'],

    components: {
        AppLayout,
        JetButton,
        JetInput,
        JetLabel,
        VueMultiselect,
    },

    setup(props) {
        const form = useForm({
            _method: props.method ?? 'PUT',
            name: props.segment?.name ?? null,
            partner_id: props.segment?.partner_id ?? null,
            esp_list_id: props.segment?.esp_list_id ?? null,
            filters: Object.assign({
                domains: [],
            }, props.segment?.filters ?? {}),
        });

        return {
            form,
            selectedPartner: computed({
                get: () => {
                    return props.partners.find((partner) => { return partner.id === form.partner_id; });
                },
                set: (value) => {
                    form.partner_id = value?.id;
                },
            }),
            addDomain(tag) {
                form.filters.domains.push(tag);
            },
            filterErrors(field) {
                return _.filter(form.errors, (value, key) => {
                    return _.startsWith(key, `filters.${field}`);
                });
            },
        };
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
